import React, { useEffect, useState } from 'react';
import { ITabs } from '../../interfaces/umbracoNodes/contentSlices';
import Tab from './tab';
import TabTitles from './tabTitles';
import * as StyledTabs from './tabs.styles';

interface Props {
	content: ITabs;
}

const Tabs = ({ content }: Props) => {
	const titles = content.Values.Items.map(item => item.Values.Title);
	const [activeTab, setActiveTab] = useState(titles[0]);

	const handleTabChange = (tabTitle: string) => {
		setActiveTab(tabTitle);

		const selectedTab = content.Values.Items.find(item => item.Values.Title === tabTitle);

		if (selectedTab && selectedTab.Values.ID) {
			const url = new URL(window.location.href);
			url.searchParams.set('tabId', selectedTab.Values.ID);
			window.history.pushState({}, '', url.toString());
		}
	};

	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search);
		const tabId = searchParams.get('tabId');

		if (tabId) {
			const matchingTab = content.Values.Items.find(item => item.Values.ID === tabId);
			if (matchingTab) {
				setActiveTab(matchingTab.Values.Title);
			}
		}
	}, [content.Values.Items]);

	return (
		<StyledTabs.Container>
			<TabTitles titles={titles} activeTab={activeTab} setActiveTab={handleTabChange} />
			<StyledTabs.TabsContainer>
				{content.Values.Items.map(item => (
					<Tab key={item.Values.ID || item.Values.Title} content={item} activeTab={activeTab} />
				))}
			</StyledTabs.TabsContainer>
		</StyledTabs.Container>
	);
};

export default Tabs;
